module.exports = __webpack_public_path__ + "static/media/close_box.8dac5b73.png";